var map = {
	"./Badges.address.js": 273,
	"./BuffiDai.address.js": 274,
	"./Burner.address.js": 275,
	"./BurnerVendor.address.js": 276,
	"./DenDai.address.js": 277,
	"./ENS.address.js": 189,
	"./ERC20Vendable.address.js": 278,
	"./Emitter.address.js": 190,
	"./Exchange.address.js": 279,
	"./Links.address.js": 280,
	"./StableCoin.address.js": 281,
	"./VendingMachine.address.js": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;